/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InvitationDto } from '../../models/invitation-dto';

export interface GetInvitation$Params {
  invitationCode: string;
}

export function getInvitation(http: HttpClient, rootUrl: string, params: GetInvitation$Params, context?: HttpContext): Observable<StrictHttpResponse<InvitationDto>> {
  const rb = new RequestBuilder(rootUrl, getInvitation.PATH, 'post');
  if (params) {
    rb.path('invitationCode', params.invitationCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InvitationDto>;
    })
  );
}

getInvitation.PATH = '/api/supply-chain/invitation/{invitationCode}';
